/**
 * Large Image Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initLargeImage() {
        const blocks = document.querySelectorAll('.large-image');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] large-image block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLargeImage);
    } else {
        initLargeImage();
    }
})();